import React from "react";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";

const SurahSection = ({ services, printable }) => {
  return (
    <React.Fragment>
      {services.map((surah) => (
        <Col lg={4} key={surah.id} className="mt-1">
          <div className="services-box surah-service">
          <Link to={`/surah-list/${surah.id}${printable ? `?printable=true`: ''}`} style={{ textDecoration:'none', color:'inherit' }}>
            <h5 className="pt-0 surah-list">{`${surah.id}. ${surah.name}`}</h5>
          </Link>
          </div>
        </Col>
      ))}
    </React.Fragment>
  );
};

export default SurahSection;
